/**
 * Sep-3 role tiers: one hierarchical role per user, displayed as Admin / User /
 * Viewer. The backend keeps richer keys (rbac_role: FIRM_ADMIN / END_USER /
 * VIEWER / PLATFORM_ADMIN; legacy role: admin / user), but organizations only
 * ever see and set these three. `rbac_role` is authoritative when present.
 */
export type RoleTier = 'admin' | 'user' | 'viewer';

export function tierOf(rbacRole?: string | null, legacyRole?: string | null): RoleTier {
  const r = (rbacRole || '').toUpperCase();
  if (r === 'FIRM_ADMIN' || r === 'PLATFORM_ADMIN') return 'admin';
  if (r === 'VIEWER') return 'viewer';
  if (r === 'END_USER' || r === 'TEAM_LEAD') return 'user';
  // Fall back to the legacy column when no RBAC assignment is present.
  return (legacyRole || '').toLowerCase() === 'admin' ? 'admin' : 'user';
}

export const TIER_LABEL: Record<RoleTier, string> = {
  admin: 'Admin',
  user: 'User',
  viewer: 'Viewer',
};
